// removed by extract-text-webpack-plugin
module.exports = {"backgroundContainer":"_2heTJgVthAyTh77XxqCeWb","otherInfoContainer":"_1bFEHkXg3rVMEFfOLtHbGr","summaryContainer":"_2dZIe5EKlsLLrnH1PR6e-U","motherName":"gITMBpIfXSDCEiA1r8yNB"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/patientPages/informationHistory/SocialHistory.scss
// module id = 418
// module chunks = 0